import * as React from 'react';

import { IMediaItemDesktopSchema } from '../FullscreenGallery';
import { Image } from './Image';

const slideErrorImg = require('../slide_error.svg');
const slideError = { text: 'Ошибка загрузки :(', img: slideErrorImg };

export const ImageSlide = ({ media, index }: { media: IMediaItemDesktopSchema; index: number }) => {
  return <Image src={media.fullUrl} error={slideError} spinnerSize={32} key={index} />;
};
